var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityDietIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.285 2.42093C1.77955 4.99274 -0.582071 14.3037 1.97852 22.9635C4.5391 31.6234 11.0523 36.3529 19.5577 33.7811C28.0631 31.2093 39.0855 26.8715 36.525 18.2117C33.9644 9.55179 18.7904 -0.150877 10.285 2.42093Z",
    fill: "#FFEDD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8805 14.2593C19.2547 13.6344 19.8468 12.7401 20.5947 11.8819H20.5956C21.229 11.1536 22.4694 10.2188 22.4694 10.2188C22.6559 10.0779 22.6359 9.88169 22.4239 9.78293L20.9246 9.08228C20.7126 8.98309 20.4244 9.05546 20.284 9.24233C20.284 9.24233 19.1751 10.8331 17.8699 14.2193C13.8345 12.394 9.99866 14.9506 9.99866 19.3963C9.99866 24.04 13.5714 31.0938 18.4029 28.9646C23.4915 31.1666 26.8097 24.0404 26.8097 19.3963C26.8097 14.9123 23.3616 12.2833 18.8805 14.2593Z",
    fill: "#5F4728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7884 12.662C18.0217 12.6425 18.2277 12.436 18.2464 12.2032C18.2464 12.2032 18.3963 10.3872 17.1307 9.12044C15.8613 7.85321 14.0488 8.00432 14.0488 8.00432C13.8155 8.0239 13.6095 8.23035 13.5903 8.4632C13.5903 8.4632 13.4379 10.28 14.7052 11.5472C15.9716 12.8132 17.7884 12.662 17.7884 12.662Z",
    fill: "#A78254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDietIcon);
export default __webpack_public_path__ + "static/media/activity-diet-icon.38a13b055d11a1a41dda0fbe50c0c9b7.svg";
export { ForwardRef as ReactComponent };